import { SAGA_ACTIONS } from '../../_config'
import { ActionExtended } from '../../_config/interfaces'
import { Dialog } from '../../_config/types'

export interface TopLearningReducer {
    topLearningData: Dialog
}
const initialState: TopLearningReducer = { topLearningData: null }

const TopLearningReducer = (state = initialState, action: ActionExtended) => {
    if (action.type === SAGA_ACTIONS.TOP_LEARNINGS.GET_LEARNINGS) {
        return { ...state, topLearningData: action.payload }
    }

    return state
}

export default TopLearningReducer
